export const generalDate = 'MM/dd/yyyy';
export const generalDateDotted = 'MM.dd.yyyy';
export const generalDateNoDivider = 'MMddyyyy';
export const generalTime = 'h:mm aa';
export const generalTime2 = 'hh:mm a';
export const generalDateTime = 'MM/dd/yyyy h:mm aa';
export const dateRequestFormat = 'yyyy-MM-dd';
export const generalDateAtTime = `${generalDate} 'at' ${generalTime}`;
export const monthDay = 'MMM d';
export const monthDayPadded = 'MMM dd';
export const dayPadded = 'dd';
export const monthDayYear = 'MMM d, yyyy';
export const monthDayYearPadded = 'MMM dd, yyyy';
export const monthYear = 'MMM yyyy';
